class Search {
  container = document.querySelector('.u-search')
  searchField = document.querySelector('.u-search_field')
  clearButton = document.querySelector('.u-search_clear')

  hasSearchTerm = window.location.search.includes('query')

  constructor() {
    this.toggleCancelButton()

    this.searchField.addEventListener('keyup', () => {
      this.toggleCancelButton()
    })
    this.clearButton.addEventListener('click', this.clearSearch.bind(this))
  }

  toggleCancelButton() {
    if (this.searchField.value.length > 0) {
      this.container.classList.add('u-search--populated')
    } else if (!this.hasSearchTerm) {
      this.container.classList.remove('u-search--populated')
    }
  }

  clearSearch() {
    window.location = window.location.pathname
  }
}

document.addEventListener('turbolinks:load', function () {
  if (document.querySelector('.u-search')) {
    new Search()
  }
})
